import { render, staticRenderFns } from "./NecessidadeEspecial.vue?vue&type=template&id=19ed9b57&"
import script from "./NecessidadeEspecial.vue?vue&type=script&lang=js&"
export * from "./NecessidadeEspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports